export const gtmGettyNoResultsEvent = (productName: string) => ({
  event: 'search_GettyImage_notfound',
  eventLabel: `No results for-${productName}`,
});

export default gtmGettyNoResultsEvent;
